import { CascadeFailed } from "components/UI/Cascade/CascadeFailed.tsx";

export const CascadeChoice = () => {
    // TODO CHOICE
    return <CascadeFailed />;
};
